// Multivariate Dependencies
import React from 'react';
// Components
import Icon from '../Icons/Icon';
import { ContainerLegacy } from '../styles/Containers/ContainerLegacy';
// Styles
import { baseTheme } from '../common/styles/themes/styles/baseTheme';
/**
 * Tab component to use in the tab bar
 *
 * @deprecated Do not use legacy components anymore.
 * @param {TabProps} props { icon, title, onClick, active }
 * @returns {React.ReactElement} - returns a tab switch
 */
export var Tab = function (_a) {
    var icon = _a.icon, title = _a.title, onClick = _a.onClick, active = _a.active;
    return (React.createElement(ContainerLegacy, { as: 'div', "data-testid": 'tabSwitch', onClick: onClick, border: '1px solid grey', borderRadius: '6px 6px 0 0', padding: '0 5px', height: '24px', display: 'flex', alignItems: 'center', backgroundColor: baseTheme.backgroundTertiary, opacity: active ? 1 : 0.6, borderBottom: '0', hoverEffects: active ? 'opacity: 1' : 'opacity: 0.8' },
        icon !== 'undefined' && (React.createElement(ContainerLegacy, { margin: '4px 4px 0 0', "data-testid": 'tabSwitchIcon' },
            React.createElement(Icon, { icon: icon }))),
        React.createElement("div", { "data-testid": 'tabSwitchTitle' }, title)));
};
//# sourceMappingURL=Tab.js.map